import * as Crypto from "../Utils/Crypto";
import axios from 'axios';
import {getBaseUrl, Wrapper as DecentralizeWrapper} from './DecentralizeWrapper'
import { URLWrapper } from "./URLWrapper";

let isRefreshing = false;
axios.defaults.timeout = 62500 * 3;
axios.interceptors.response.use(response => {
	return response;
}, function (error) {
	const err = error.response;
	console.log(err)
	if (err && (err.status === 401) && err.config) {
		const originalRequest = err.config;
		if (!isRefreshing) {
			isRefreshing = true;
			getRefreshToken()
				.then(success=> {
					onRefreshed(success.data.access_token)
				}).catch((err) => {
					window.localStorage.clear();
					window.location.reload()
				});
		}
		if(err.config && err.config.url &&  err.config.url.includes(`token/refresh`)){
			return Promise.reject(err);
		}else{
			return new Promise((resolve, reject) => {
				subscribeTokenRefresh(token => {
					originalRequest.headers['Authorization'] = 'Bearer ' + token;
					resolve(axios(originalRequest));
				});
			});
		}

	} else {
		if (err)
			return Promise.reject(err);
	}
});

axios.interceptors.request.use(async function (config) {
	const token = Crypto.get('token');
	if (token !== null && token !== "") {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
}, function (err) {
	return Promise.reject(err);
});

function getRefreshToken() {
	let refreshtoken = Crypto.get("refresh_token");
	if (!refreshtoken) {
		window.localStorage.clear()
		window.location.reload();
	}
	return axios.post(`${getBaseUrl()}/auth/token/refresh`, {
		token: refreshtoken
	});
}

let refreshSubscribers = [];

const subscribeTokenRefresh = (cb) => {
	refreshSubscribers.push(cb);
}

const onRefreshed = (token) => {
	setTokens(token);
	isRefreshing = false;
	refreshSubscribers = refreshSubscribers.filter(cb => {
		cb(token);
		return false;
	});
	refreshSubscribers = [];
}

const setTokens = (token) => {
	Crypto.set('token', token);
}


const MainApis = new DecentralizeWrapper()
const get = MainApis.get;
const patch = MainApis.patch;
const post = MainApis.post;
const deleteApi = MainApis.delete;

const reportApis = new URLWrapper(MainApis.getReportsUrl());
const reportGet = reportApis.get;
const reportPatch = reportApis.patch;
const reportPost = reportApis.post;

export default axios;
export {
	axios,
	get,
	post,
	patch,
	deleteApi,
	reportGet,
	reportPatch,
	reportPost
}
